import {initializeApp} from 'firebase/app';
import {connectAuthEmulator, getAuth, setPersistence, initializeAuth, indexedDBLocalPersistence} from "firebase/auth";
import {connectFunctionsEmulator, getFunctions} from 'firebase/functions';
import {initializeAppCheck, ReCaptchaV3Provider, getToken} from "firebase/app-check";
import { Capacitor } from '@capacitor/core';

const firebaseConfig = {
  apiKey: "AIzaSyCZjjEdNtwjDPAEvl-70wrJfk82jyGY2Xc",
  authDomain: "clgmbh-charge-line.firebaseapp.com",
  projectId: "clgmbh-charge-line",
  storageBucket: "clgmbh-charge-line.appspot.com",
  messagingSenderId: "526529534665",
  appId: "1:526529534665:web:5303a3a25ac09e09344b18",
};

const region = 'europe-west3';

const firebase = initializeApp(firebaseConfig);
let auth 

if (Capacitor.getPlatform()) {
  auth = initializeAuth(firebase, {persistence: indexedDBLocalPersistence})
} else {
  auth = getAuth(firebase);
  setPersistence(auth,indexedDBLocalPersistence)
}

const functions = getFunctions(firebase, region);

if ( location.hostname === "127.0.0.1" || location.hostname.match(/^192\.168\./) || location.hostname.match(/^10\.15\./) ||  location.hostname === "localhost") {
  const token = process.env.VUE_APP_FIREBASE_APPCHECK_DEBUG_TOKEN || true;
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = token;
  token == true ? console.info("Erstelle eine Datei mit dem Namen  \".env.local\" in \"./\" um darin den VUE_APP_FIREBASE_APPCHECK_DEBUG_TOKEN zu speichern.") : console.log("appcheck is using Local env");
}

const appCheck = initializeAppCheck(firebase, {
  provider: new ReCaptchaV3Provider('6LfnSXwqAAAAABhsgU-Cq4Ywy9N2YS3QH42Du42O'),
  isTokenAutoRefreshEnabled: true
});

const appCheckToken = getToken(appCheck, /* forceRefresh= */ true);

if (location.hostname === '127.0.0.1') {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
// console.log(location.hostname)
if ( location.hostname === '10.0.1.4') {
  connectAuthEmulator(auth, 'http://10.0.1.4:9099');
  connectFunctionsEmulator(functions, '10.0.1.4', 5001);
}

export {firebase, region, auth, appCheck, appCheckToken, functions} 